import React from 'react';
import {observer} from 'mobx-react';
import store from '../../../../s';
import {ICheckoutStep} from '../../../../i';

const MobileHeader = observer(() => {
    return (
        <div className="cs-mobile-header">
            <div className="top">{store.checkout.cstep === ICheckoutStep.cart ? 'Your Cart' : 'Checkout'}</div>
            {/* <div className='desc'>{this.cartItemTotal} items: <span className='price'>{currency(this.total)}</span></div> */}
        </div>
    );
});

export default MobileHeader;
